var _circle, _path, _circle2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTestStation = function SvgTestStation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6562,
    cy: 36.3804,
    r: 20,
    fill: "#463900",
    stroke: "#BDBDBD",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7689 27.4011C28.2873 26.1059 30.1825 26.1925 30.5805 27.5295L30.6151 27.6676L33.7438 42.7357L36.9275 35.7176C37.1711 35.1806 37.804 34.9427 38.341 35.1862C38.8781 35.4298 39.116 36.0627 38.8724 36.5997L34.8775 45.4063C34.28 46.7235 32.3466 46.5092 32.0525 45.0931L29.0331 30.5531L26.4458 39.0314C26.2539 39.6602 25.6735 40.09 25.016 40.09H23.1049C22.5152 40.09 22.0372 39.6119 22.0371 39.0222C22.0371 38.4325 22.5152 37.9545 23.1049 37.9545H24.5418L27.7217 27.5354L27.7689 27.4011Z",
    fill: "#F9BA15"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.902,
    cy: 36.2042,
    r: 2.97422,
    fill: "#F9BA15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6597 33.4217C42.3144 33.0764 42.3144 32.5166 42.6597 32.1714C43.0049 31.8261 43.5647 31.8261 43.91 32.1714C46.1372 34.3986 46.1372 38.0096 43.91 40.2368C43.5647 40.5821 43.0049 40.5821 42.6597 40.2368C42.3144 39.8916 42.3144 39.3318 42.6597 38.9865C44.1964 37.4498 44.1964 34.9584 42.6597 33.4217Z",
    fill: "#F9BA15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9334 31.0053C45.5882 30.6601 45.5882 30.1003 45.9334 29.755C46.2787 29.4098 46.8385 29.4098 47.1837 29.755C50.7454 33.3168 50.7454 39.0914 47.1837 42.6532C46.8385 42.9984 46.2787 42.9984 45.9334 42.6532C45.5882 42.3079 45.5882 41.7481 45.9334 41.4029C48.8046 38.5317 48.8046 33.8765 45.9334 31.0053Z",
    fill: "#F9BA15"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTestStation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "test-station.8d1b191f888b3e49bf8a70c85a86f019.svg";